import ButtonSpinner from '../../_common/components/buttons/buttonSpinner/buttonSpinner'
import CanvasDraw from "react-canvas-draw";
import getLangByShopId from "../../_common/utils/getLang";
import {  CF, E, FR, R } from "../../_common/layout";
import { AppPage } from "../../_common/components/app-page";
import { CONDITIONS_PAGES_MAPPING, LANG_PS_MAPPING} from "../../constants";
import { Checkbox } from "../../_common/forms/components/Checkbox/Checkbox";
import { Component, createRef, Fragment, h } from "preact";
import { RadioCheckbox } from '../../_common/forms/components/components';
import { Terms } from "../components/terms";
import { connect } from "react-redux";
import { fetchCmsPages } from "../../_rx/cms-pages/actions";
import { t } from '../../_i18n';
import { uploadSignature } from "../../_rx/student/actions";

import './signature-page.scss';


let Signature = class extends Component {
    
    async componentDidMount() {

        if(!this.props.cms_pages)
            await this.props.fetchCmsPages(null);
    }

    canvasRef = createRef();
    state = {
        uploading: false,
        sign: null,
        useOfImages: null,
        dataProtection: false,
        refuseCommercialInfo: false,
        reload: false
    }

    async upload(img, docId) {
        await this.props.uploadDocument(this.props.auth.loggedUser.id, img, docId);
    }

    clear() {
        this.canvasRef.current.clear()
        this.setState({ sign: null })
    }

    refreshPage = () => {
        this.setState(
          {reload: true},
          () => this.setState({reload: false})
        )
      }

    sleep = ms => new Promise(r => setTimeout(r, ms));

    async save() {
        await this.setState({ uploading: true });
        await this.props.uploadSignature(
            this.props.auth.loggedUser.id,
            this.canvasRef.current.canvas.drawing.toDataURL(),
            this.state.useOfImages,
            this.state.refuseCommercialInfo
        );
        await this.sleep(2000);
        window.location.reload();
    }

    async validateForm() {
        if(this.state.useOfImages === null){
            var element = document.getElementById('allow-use-images-radio-checkbox');
            document.getElementById('input-schedule-error').style.display = 'block';
            window.scrollTo({ top: element.offsetTop-50, behavior: 'smooth'});
        }
    }

    getCmsPageContent = (documentToSign, lang) => {
        let ps_id_lang = LANG_PS_MAPPING[lang];
        let cms_page_id = CONDITIONS_PAGES_MAPPING[documentToSign];
        let page = this.props.cms_pages.find((cms_page) => ((cms_page_id == cms_page.id_cms) && (cms_page.id_lang == ps_id_lang)));
        return page.content;
    }

    handleChecked = (value) => {
        this.setState({refuseCommercialInfo: value})
    }

    handleRadioBox = (value) => {
        this.setState({useOfImages: value})
        document.getElementById('input-schedule-error').style.display = 'none';
    }    

    handleSign = (e) => this.setState({ sign: e.canvas.drawing.toDataURL() })

    render({ cms_pages, status, student }) {

        /* DEPRECATED */
        /* we are not checking if the student has previously signed a document type cause they must sign on each sale */

        /*
        // we check if we stored the data when the conditions were signed on DB
        const hasSignedConditionspreviously = status.student_meta.has_signed_conditions_previously
        // for those old students which we don't have the date when they signed the conditions
        const blocksToCompare = (status.student_meta.has_academic_program_document_types) ? ['1', '2', '3', '4', '6'] : ['1', '2', '3', '4']
        const isOldStudent = blocksToCompare.find(s => status.blocks[s].status.id === STATUS_ID_VALIDATED) 
        */

        const lang = getLangByShopId(status.student_meta.shop_id);
        
        const content = cms_pages && this.getCmsPageContent(status.student_meta.document_type_to_be_signed, lang);

        return student && content && <Fragment>

            {/*hasSignedConditionspreviously || isOldStudent ? <ConditionsUpdated name= {student.data.name}/> : ''*/}
            
            <Terms content= {content}/>

            <div style="padding-top:32px" />

            <CF className="sm-card max-width-sm">
                <div className={"sm-p-x2-top sm-p-x2-bottom sm-p-left sm-p-right t-justify"}>
                    <h2>{t('signature_page_commercial_info_title')}</h2>
                    <div dangerouslySetInnerHTML={{ __html: t('signature_page_commercial_info') }} />
                    <div className='m-top-x2 d-flex font-18'>
                        <Checkbox
                            onChange={this.handleChecked}
                            value={this.state.refuseCommercialInfo}
                            label={
                                <span>
                                    { t('signature_page_commercial_info_checkbox') }
                                </span>
                            }
                        />
                    </div>
                </div>
            </CF>

            <div style="padding-top:32px" />

            <CF className="sm-card max-width-sm">
                <div className='sm-p-x2-top sm-p-x2-bottom sm-p-left sm-p-right t-justify'>
                    <h2 className='m-bottom'>{t('Cesión de los derechos de imágen')}</h2>
                    <div className='m-bottom'
                        dangerouslySetInnerHTML={{ __html: t('signature_page_accept_images') }}></div>
                    <div className='p-top'
                        dangerouslySetInnerHTML={{ __html: t('signature_page_select_option') }}></div>
                    <FR id="allow-use-images-radio-checkbox" className=' m-bottom flexrow'>
                        <E className='sm-col-20 col-50'>
                            <RadioCheckbox
                                label={t('Aceptar')}
                                type='radio'
                                onChange={() => {
                                    this.handleRadioBox(true)
                                }}
                                defaultValue={this.state.useOfImages}
                            />
                        </E>
                        <E className='sm-col-20 col-50'>
                            <RadioCheckbox
                                label={t('Rechazar')}
                                type='radio'
                                onChange={() => {
                                    this.handleRadioBox(false)
                                }}                                
                                defaultValue={this.state.useOfImages === false}
                            />
                        </E>
                        <div id='input-schedule-error' className='element input-schedule-error' style="display:none">{t('Este campo es obligatorio')}</div>
                    </FR>
                    <hr></hr>
                    <div className='p-top'>{t('signature_page_accept_images_2')}</div>
                </div>
            </CF>

            <div style="padding-top:32px" />


            <div className="max-width margin-auto" style={{ paddingLeft: '4px' }}>
                <h1 className='no-margin m-bottom'>{t('Deja tu firma aquí')}</h1>
            </div>

            <CF className={"desktop-white max-width-sm dashed" + (this.state.uploading ? ' disabled-link' : '')}>
                <CanvasDraw brushRadius={5} brushColor="#000" canvasWidth="100%" ref={this.canvasRef} hideGrid={true}
                    onChange={this.handleSign} />
            </CF>

            <FR className="max-width-sm margin-auto t-right m-top flex-center-y ">
                <div id="accept-signature" className="flexrow sm-col-33 col-50" onClick={() => this.validateForm()}>
                    <ButtonSpinner 
                        type="button"
                        className="btn btn-primary col-100"
                        onClick={() => this.save()}
                        disabled={(this.state.uploading || !this.state.sign) || (this.state.useOfImages === null)}
                        showSpinner={this.state.uploading}
                    >
                        {t('Aceptar')}
                    </ButtonSpinner>
                </div>
                <button type="button" className="btn btn-ghost sm-col-33 col-50" onClick={() => this.clear()} disabled={this.state.uploading}>{t('Borrar')}</button>
                <div className="col-30 flex-center-x t-underline t-center text-primary t-upper cursor-pointer m-l d-none sm-d-block" onClick={() => history.back()}>{t('Cancelar')}</div>
            </FR>

        </Fragment>;
    }
};

Signature = connect(({ auth, status, student, cms_pages }) => ({ auth, status, student, cms_pages }),
    {
        uploadSignature,
        fetchCmsPages
    })(Signature);


const SignaturePage = ({ history }) =>
    <AppPage
        name="signature"
        className="max-width-sm"
    >
        <Signature />
    </AppPage>
    ;

export default SignaturePage;
